"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
var MAX_CHART_HEIGHT = 100000;
function getChartHeight(numOfBars) {
    var base = 60;
    return Math.min(MAX_CHART_HEIGHT, numOfBars * base + 300);
}
function generateSeries(dataRows, legends, zIndex, stack, xAxis, yAxis) {
    if (zIndex === void 0) { zIndex = 6; }
    if (stack === void 0) { stack = 'main'; }
    var groupByName = dataRows.groupByName, projectColor = dataRows.projectColor;
    var utilService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.NONE);
    var series = [];
    var categories = [];
    groupByName = Object.keys(groupByName)
        .sort()
        .reduce(function (acc, key) {
        acc[key] = groupByName[key];
        return acc;
    }, {});
    var _loop_1 = function (legend) {
        var tagKey = legend['tag'];
        var tagColor = legend['color'];
        var overallDiscovery = { "Discovery": [], "Specify": [], "Navigate": [], "Manage": [] };
        Object.entries(groupByName).forEach(function (e, index) {
            var key = e[0], value = e[1];
            var data = value;
            var discoveryData = { "Discovery": 0, "Manage": 0, "Navigate": 0, "Specify": 0 };
            var finalScore = 0;
            data.map(function (issue) {
                discoveryData[issue.discoveryGrid] += issue.y;
                finalScore += issue.y;
                return issue;
            });
            var sortedKeys = Object.keys(discoveryData).sort(function (a, b) { return discoveryData[b] - discoveryData[a]; });
            sortedKeys.forEach(function (key) {
                overallDiscovery[key].push(discoveryData[key]);
            });
            categories.push(key);
        });
        Object.entries(overallDiscovery).forEach(function (e, index) {
            var key = e[0], value = e[1];
            var color = utilService.zoneColorDarker[key.toUpperCase()];
            series.push({
                name: "<div style='font-weight: normal;'>" + key + "</div>",
                color: color,
                zIndex: zIndex,
                data: value,
                stack: stack
            });
        });
    };
    for (var _i = 0, legends_1 = legends; _i < legends_1.length; _i++) {
        var legend = legends_1[_i];
        _loop_1(legend);
    }
    return { series: series, categories: categories };
}
function assignXValue(mainSeriesData, siblingSeriesData) {
    var totalBars = mainSeriesData.length;
    mainSeriesData.forEach(function (row, index) {
        row.x = index;
    });
    if (siblingSeriesData && siblingSeriesData.length > 0) {
        var positionFix_1 = 0.05;
        mainSeriesData.forEach(function (row, index) {
            for (var _i = 0, siblingSeriesData_1 = siblingSeriesData; _i < siblingSeriesData_1.length; _i++) {
                var sibRow = siblingSeriesData_1[_i];
                if (!sibRow.x && sibRow.name === row.name) {
                    sibRow.x = index + positionFix_1;
                    break;
                }
            }
        });
        siblingSeriesData.filter(function (row) { return !row.x; }).forEach(function (row) {
            var rowCopy = __assign({}, row, { x: totalBars, y: 0 });
            siblingSeriesData.push(rowCopy);
            row.x = totalBars + positionFix_1;
            totalBars += 1;
        });
    }
    return totalBars;
}
function getGroupedData(tableJSON) {
    var a = tableJSON.sort(function (a, b) { return (a.ValueGIvenSuccess < b.ValueGIvenSuccess ? 1 : -1); });
    var projects = (tableJSON.map(function (obj) { return obj.projectName; })).slice().sort();
    var projectColor = {};
    projects.forEach(function (p, index) { return (projectColor[p.replace(/\s\s+/g, "_")] = makeColor(index)); });
    var groupBy = function (array, property) {
        return array.reduce(function (grouped, element) {
            var _a;
            return (__assign({}, grouped, (_a = {}, _a[element[property]] = (grouped[element[property]] || []).concat([element]), _a)));
        }, {});
    };
    var groupByName = groupBy(tableJSON, "projectName");
    return { groupByName: groupByName, projectColor: projectColor };
}
exports.getGroupedData = getGroupedData;
function generateChartOptionts(graph, options, chartHeight, series, drilldown, chartType, xDisplay, xAxisOptions, categories) {
    var chartTitle = options.chartTitle, settings = options.settings, timestamp = options.timestamp;
    return {
        chart: {
            renderTo: 'chartContainerExp',
            type: chartType,
            height: 600,
            zoomType: 'xy'
        },
        title: {
            text: chartTitle
        },
        xAxis: {
            categories: categories
        },
        yAxis: [{
                min: graph.minValue,
                max: graph.maxValue,
                title: {
                    text: xDisplay
                },
                labels: {
                    formatter: function () {
                        return Intl.NumberFormat("en-US", xAxisOptions ? xAxisOptions : {}).format(Number(this.value));
                    }
                }
            }],
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                return "<b>" + this.key + "</b><br /><i>" + this.series.name + "</i>: " + this.y.toFixed(settings.decimals);
            }
        },
        plotOptions: {
            series: {
                stacking: 'normal'
            }
        },
        series: series,
        responsive: {
            rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            enabled: false
                        }
                    }
                }]
        }
    };
}
function filterZeroImpactIgnorance(dataGot) {
    return dataGot.filter(function (item) { return item.impact > 0 && item.ignorance > 0 && (item.title != "" || item.issue != ""); });
}
exports.filterZeroImpactIgnorance = filterZeroImpactIgnorance;
function formatForBar(dataGot, xAxisKey, xDisplay) {
    var utilService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.NONE);
    return dataGot.map(function (item, index) {
        var borderColor = "gray";
        var nameGot = item.pLabel;
        return {
            "name": nameGot,
            "pLabel": nameGot,
            "projectName": item.name,
            "tags": ["all"],
            "colorTag": "2021 Active",
            "groups": null,
            "y": item[xAxisKey],
            "expExist": item.Experiments,
            "status": item.status,
            "expName": item.expName !== "" ? item.expName : "Unnamed",
            "selectedKey": xDisplay,
            "borderWidth": 1,
            "borderColor": borderColor,
            "issueTitle": item.title,
            "issueName": item.issue,
            "discoveryGrid": item.DiscoveryGrid,
            "color": utilService.zoneColorDarker[item.DiscoveryGrid.toUpperCase()]
        };
    });
}
exports.formatForBar = formatForBar;
function makeColor(colorNum) {
    var hues = [
        0, 20, 30, 40, 50, 60, 80, 120, 160, 190, 210, 230, 260, 290, 330, 360,
    ];
    var lights = [60, 50, 50, 50, 50, 50, 50, 55, 50, 55, 67, 77, 73, 67, 60, 60];
    var goldenFrac = 0.5 * (3 - Math.sqrt(5));
    var x = ((colorNum * goldenFrac) % 1.0) * (hues.length - 1);
    var i = Math.floor(x);
    var f = x % 1.0;
    var hue = (1.0 - f) * hues[i] + f * hues[i + 1];
    var light = (1.0 - f) * lights[i] + f * lights[i + 1];
    var color = "hsl( " + Math.round(hue * 100) / 100 + ", 100%, " + Math.round(light * 100) / 100 + "% )";
    // Check if the generated color is white, and if so, regenerate it
    if (color.toLowerCase() === "hsl( 0, 100%, 100% )") {
        return makeColor(colorNum + 1); // Recursively generate a new color
    }
    return color;
}
exports.makeColor = makeColor;
function getChartOptions(graph, options, xAxisData, yAxisData) {
    var chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp, chartType = options.chartType;
    var mainSeriesData = graph.mainRows;
    var siblingSeriesData = (graph.siblingRows || []).sort(function (a, b) { return b.y - a.y; });
    var totalBars = assignXValue(mainSeriesData, siblingSeriesData);
    var chartHeight = getChartHeight(totalBars);
    var xAxisKey = xAxisData['data'][xAxisData['selected']]['key'];
    var xDisplay = xAxisData['data'][xAxisData['selected']]['display'];
    var xAxisOptions = JSON.parse(xAxisData['data'][xAxisData['selected']]['options']);
    var mainFilteredData = filterZeroImpactIgnorance(mainSeriesData) || [];
    var mainFormattedData = formatForBar(mainFilteredData, xAxisKey, xDisplay) || [];
    mainFormattedData = mainFormattedData.sort(function (a, b) { return b.y - a.y; });
    var sibFilteredData = filterZeroImpactIgnorance(siblingSeriesData) || [];
    var sibFormattedData = formatForBar(sibFilteredData, xAxisKey, xDisplay) || [];
    sibFormattedData = sibFormattedData.sort(function (a, b) { return b.y - a.y; });
    var mainGroupedData = getGroupedData(mainFormattedData);
    var siblingGroupedData = getGroupedData(mainFormattedData);
    var _b = generateSeries(mainGroupedData, legends, 6, 'main', xAxisData, yAxisData), series = _b.series, categories = _b.categories;
    var drilldown = graph.mainDrillDown.map(function (item) {
        item.stack = 'main';
        return item;
    });
    if (siblingSeriesData.length > 0) {
        var siblingSeries = generateSeries(siblingGroupedData, siblingLegends, 5, 'sib', xAxisData, yAxisData);
        series = series.concat(siblingSeries);
        drilldown = drilldown.concat(graph.siblingDrillDown.map(function (item) {
            item.stack = 'sib';
            return item;
        }));
    }
    return generateChartOptionts(graph, options, chartHeight, series, drilldown, chartType, xDisplay, xAxisOptions, categories);
}
exports.getChartOptions = getChartOptions;
//# sourceMappingURL=discovery-breakdown.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/discovery-breakdown/discovery-breakdown.chart.js